import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_all",
  "use": "icon-icon_all-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_all\"><g transform=\"translate(5.5 3.308)\" stroke=\"#FFF\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\"><rect y=\"22.692\" width=\"13\" height=\"13\" rx=\"2\" /><rect y=\"2.692\" width=\"13\" height=\"13\" rx=\"2\" /><rect transform=\"rotate(-45 26.5 9.192)\" x=\"20\" y=\"2.692\" width=\"13\" height=\"13\" rx=\"2\" /><rect x=\"20\" y=\"22.692\" width=\"13\" height=\"13\" rx=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol